$shm_hitalama_map_widget_float_drawing $shm_hitalama_map_widget_float
	scrollable false
	controls /
		<= Svg $mol_view
			dom_name \svg
			dom_name_space \http://www.w3.org/2000/svg
			attr *
				^
				viewBox <= view_box \0 0 1 1
				preserveAspectRatio \none
			event *
				pointerdown? <=> content_pointerdown? null
			sub <= stroke_views /
				<= Stroke* $mol_view
					dom_name \polyline
					dom_name_space \http://www.w3.org/2000/svg
					attr *
						^
						points <= stroke_points* \
						fill \none
						stroke <= stroke_color* \#808080
						stroke-width <= stroke_width* \4
						stroke-linecap \round
						stroke-linejoin \round
	settings_content /
		<= Drawing_settings $mol_list
			sub /
				<= Line_labeler $mol_labeler
					title \Линия
					content /
						<= Line_color $shm_hitalama_color_pick
							color? <=> line_color? \#808080
							color_default \#808080
						<= Line_color_hex $mol_string
							value? <=> line_color? \#808080
						<= Line_width $shm_hitalama_map_borderwidth
							border_width? <=> line_width? 4
